<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-left xs12 md3 px-3 v-if="!currentCarrier">
            <v-text-field v-model="search" append-icon="search" placeholder="Search" style="padding-bottom: 0 !important;"></v-text-field>
          </v-flex>
          <v-flex text-xs-left xs12 md3 v-if="currentCarrier">
            <v-btn flat v-if="canPrintShipments" @click="printShipments" class="bw-3">Print</v-btn>
            <v-btn flat v-if="canPrintShipments" @click="excelShipmentReport" class="bw-3">Excel</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 md9>
            <v-btn flat v-if="!currentCarrier" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentCarrier" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentCarrier" v-on:click="editNewCarrier" class="bw-6">Create new carrier</v-btn>
            <v-btn flat v-if="currentCarrier" :disabled="saveButtonDisabled" v-on:click="save" class="bw-3">{{ currentCarrier.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="canDelete" v-on:click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentCarrier" v-on:click="cancel" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentCarrier" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredCarriers" :search="search" hide-actions>
              <template v-slot:items="props">
                <tr @click="selectRow(props.item)" class="selectable">
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.vat }}</td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.phone }}</td>
                  <td class="text-xs-left">{{ props.item.mobile }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <Panel v-if="currentCarrier">
        <PanelColumn title="Carrier">
          <v-flex xs4 md2>
            <v-label>Name</v-label>
          </v-flex>
          <v-flex xs8 md5>
            <v-text-field color="teal" v-model="currentCarrier.name" ref="name" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md1/>
          <v-flex xs4 md2>
          </v-flex>
          <v-flex xs8 md2>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>E-mail</v-label>
          </v-flex>
          <v-flex xs8 md5>
            <v-text-field color="teal" v-model="currentCarrier.email" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md1/>
          <v-flex xs4 md2>
            <v-label>VAT no.</v-label>
          </v-flex>
          <v-flex xs8 md2>
            <v-text-field color="teal" v-model="currentCarrier.vat" style="width: 120px;" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>Phone</v-label>
          </v-flex>
          <v-flex xs8 md5>
            <v-text-field color="teal" v-model="currentCarrier.phone" style="width: 120px;" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md1/>
          <v-flex xs4 md2>
            <v-label>Mobile</v-label>
          </v-flex>
          <v-flex xs8 md2>
            <v-text-field color="teal" v-model="currentCarrier.mobile" style="width: 120px;" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>Internal transporter</v-label>
          </v-flex>
          <v-flex xs8 md10>
            <v-checkbox color="teal" v-model="currentCarrier.internalTransport" :disabled="currentCarrier.internalTransportPrimary && currentCarrier.internalTransport"/>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>Primary internal transporter</v-label>
          </v-flex>
          <v-flex xs8 md10>
            <v-checkbox color="teal" v-model="currentCarrier.internalTransportPrimary" @change="internalTransportPrimaryChanged"/>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>Inactive</v-label>
          </v-flex>
          <v-flex xs8 md10>
            <v-checkbox color="teal" v-model="currentCarrier.inactive"/>
          </v-flex>
          <v-flex xs12/>
        </PanelColumn>

        <v-flex xs12 px-5 py-3 text-xs-center>
        </v-flex>

        <PanelColumn2 title="Address">
          <v-flex xs4 sm4>
            <v-label>Street</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.street" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>House no.</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Location</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.location" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Postal code</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>City</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.city" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Country</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.country" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Geo code</v-label>
          </v-flex>
          <v-flex xs4 sm4 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.latitude" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs4 sm4 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentCarrier.address.longitude" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs12 text-xs-right>
            <v-btn @click="$refs.maps.addressToGeo(currentCarrier.address)" flat>Lookup geo code</v-btn>
          </v-flex>
        </PanelColumn2>
        <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
        <PanelColumn2 style="padding-top: 25px;">
          <Maps v-model="currentCarrier.address" ref="maps" height="285px"/>
        </PanelColumn2>
      </Panel>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete carrier</v-card-title>
        <v-card-text v-if="currentCarrier">Are you sure you want to delete '{{ currentCarrier.name }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import Maps from '../components/Maps'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import axios from 'axios'

export default {
  name: 'Carriers',
  components: {Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, Maps},
  data () {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'VAT', value: 'vat', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false },
        { text: 'Mobile', value: 'mobile', sortable: false }
      ],
      carriers: [],
      currentCarrier: null,
      confirmDeleteDialog: false,
      filterInactive: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'carriers' })
    this.loadCarriers()
  },
  computed: {
    users: function () {
      return this.$store.state.user.users
    },
    saveButtonDisabled: function () {
      return !this.currentCarrier || this.currentCarrier.name.trim() === ''
    },
    canDelete: function () {
      return this.currentCarrier && this.currentCarrier.id > 0
    },
    canPrintShipments: function () {
      return this.currentCarrier && this.currentCarrier.id > 0
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredCarriers () {
      return this.carriers.filter(c => this.filterInactive ? c.inactive : !c.inactive)
    }
  },
  methods: {
    loadCarriers () {
      // console.log('Loading carriers')
      axios.get('/backend/rest/carrier/all')
        .then(response => {
          this.carriers = response.data
        })
    },
    selectRow (item) {
      for (let c of this.carriers) {
        if (c.id === item.id) {
          this.currentCarrier = c
          // console.log('Latitude is: ' + this.currentCarrier.address.latitude)
          if (this.currentCarrier.address.latitude === 0) {
            this.currentCarrier.address.latitude = ''
          }
          if (this.currentCarrier.address.longitude === 0) {
            this.currentCarrier.address.longitude = ''
          }
          break
        }
      }
      // console.log('The current carrier is: ' + this.currentCarrier.name)
    },
    editNewCarrier () {
      // console.log('Create a new carrier')
      this.currentCarrier = {
        id: 0,
        name: '',
        vat: '',
        email: '',
        phone: '',
        mobile: '',
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        },
        internalTransport: false,
        internalTransportPrimary: false
      }
      this.$nextTick(() => this.$refs.name.focus())
    },
    save () {
      // console.log('Save the carrier')
      axios.post('/backend/rest/carrier', this.currentCarrier)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadCarriers()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentCarrier = null
    },
    delete () {
      // console.log('Delete carrier: ' + this.currentCarrier.name)

      axios.delete('/backend/rest/carrier/' + this.currentCarrier.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadCarriers()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentCarrier = null
    },
    cancel () {
      this.currentCarrier = null
      this.loadCarriers()
    },
    printShipments () {
      let url = '/backend/print/carrierShipments.xhtml?carrierId=' + this.currentCarrier.id + '&title=Carrier shipments'
      window.open(url)
    },
    excelShipmentReport () {
      let url = '/backend/report/carrierShipmentReport?carrierId=' + this.currentCarrier.id
      window.open(url)
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    },
    internalTransportPrimaryChanged () {
      if (this.currentCarrier.internalTransportPrimary) {
        this.currentCarrier.internalTransport = true
      }
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Carriers.vue